import { BoundingBox, GeoCoordinates } from '@sc/data-access-models';

export function gmapBoundsToBoundingBox(
  bounds: google.maps.LatLngBounds
): BoundingBox {
  if (
    bounds.getNorthEast().lat() === bounds.getSouthWest().lat() &&
    bounds.getSouthWest().lng() === bounds.getNorthEast().lng()
  ) {
    return null;
  }
  return {
    ne: {
      lat: bounds.getNorthEast().lat(),
      lon: bounds.getNorthEast().lng(),
    },
    sw: {
      lat: bounds.getSouthWest().lat(),
      lon: bounds.getSouthWest().lng(),
    },
  };
}

export function boundingBoxEqual(
  bounds1: BoundingBox,
  bounds2: BoundingBox
): boolean {
  return (
    coordsEqual(bounds1.ne, bounds2.ne) && coordsEqual(bounds1.sw, bounds2.sw)
  );
}

export function latLngToGeoCoordinates(
  point: google.maps.LatLng
): GeoCoordinates {
  return {
    lat: point.lat(),
    lon: point.lng(),
  };
}

export function coordsEqual(
  coord1: GeoCoordinates,
  coord2: GeoCoordinates
): boolean {
  return coord1.lat === coord2.lat && coord1.lon === coord2.lon;
}
